// Full-document render of the sealy InformationPage: PageSkeleton (the React
// document shell) wrapping the existing information-page body assembly.
import React from "react";

import { templates } from "@reactivated";

import { InformationPageBody } from "../components/InformationPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.InformationPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <InformationPageBody page={props.page} />
    </PageSkeleton>
);
